module.exports = __webpack_public_path__ + "img/attachment.85d68437.svg";